import React, { useState, useEffect, useCallback, useRef } from 'react';
import io from 'socket.io-client';
import { v4 as uuidv4 } from 'uuid';
import IconImage from "../assets/img/icons/common/icon_one.svg";
import { auto, right } from '@popperjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import styled from "styled-components"
import { CMM } from '../Lib/Cmm.js';
import { Link } from "react-router-dom";

let socket = null;

const currentDate = new Date();

const year = currentDate.getFullYear() % 100;
const month = currentDate.getMonth() + 1;
const day = currentDate.getDate();
const hours = currentDate.getHours();
const minutes = currentDate.getMinutes();

const uniqueId = `${uuidv4()}-${currentDate.toISOString()}`;
const user_idx = parseInt(`${year}${month}${day}${hours}${minutes}`, 10);


// const c_user_idx = sessionStorage.getItem('user_idx');
// const u_uuid = sessionStorage.getItem('u_uuid');


const ChatPage = (props) => {

    const [textAnimation, setTextAnimation] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const messagesEndRef = useRef(null);
    const messageRef = useRef(null);

    const [c_user_idx, setUserIdx] = useState(sessionStorage.getItem('user_idx'));
    const [u_uuid, setUuid] = useState(sessionStorage.getItem('u_uuid'));
    const [img, setImg] = useState(sessionStorage.getItem('img'));

    const [isHovered, setIsHovered] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);

    useEffect(() => {

        // 채팅서버 접속
        socket = io.connect(CMM.SERVER_URL_API, { cors: { origin: '*' } });
        socket.connect();

        // console.log("소켓이 연결되었습니다.", socket);

        socket.emit('room', {
            c_idx: c_user_idx,
            u_idx: user_idx,
            u_uuid: uniqueId,
        });

        return () => {
            setMessages([])
            // chatPrevLoaded = false;

            // socket 접속 해제
            if (socket) {
                socket.disconnect();
            }
        }

    }, []);


    //고객 채팅 전송
    const handleSendMessage = useCallback((mes) => {

        console.log('handleSendM:::::', inputMessage.trim())

        if (inputMessage.trim() !== '') {
            const newMessage = {
                room_nm: uniqueId,
                text: inputMessage,
                ownerType: 'user',
                idx: user_idx,
                user_idx: c_user_idx,
                u_uuid: uniqueId,
                chatType: 'T'
            };
            if (socket) {
                setMessages((prevMessages) => [...prevMessages, newMessage]);
                socket.emit('newMessage', newMessage);
                scrollToBottom();
            }
            setInputMessage('');
        } else {

            const newMessage = {
                room_nm: uniqueId,
                text: mes,
                ownerType: 'user',
                idx: user_idx,
                user_idx: c_user_idx,
                u_uuid: uniqueId,
                chatType: 'BS'
            };
            if (socket) {
                setMessages((prevMessages) => [...prevMessages, newMessage]);
                socket.emit('newMessage', newMessage);
                scrollToBottom();
            }
            setInputMessage('');
        }
    }, [inputMessage]);

    //스크롤 이벤트
    const scrollToBottom = () => {
        setTimeout(() => {
            // 화면이 다 그려지기 전에 스크롤을 실행하면 원하는 위치까지 내려가지 못함. 잠깐 대기 후 스크롤
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
        setTimeout(() => {
            // 화면이 다 그려지기 전에 스크롤을 실행하면 원하는 위치까지 내려가지 못함. 잠깐 대기 후 스크롤
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 300);

        setTimeout(() => {
            // 화면이 다 그려지기 전에 스크롤을 실행하면 원하는 위치까지 내려가지 못함. 잠깐 대기 후 스크롤
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 2200);
    };

    //엔터키 이벤트
    const activeEnter = (e) => {
        if (e.nativeEvent.isComposing) { 	   // isComposing 이 true 이면 
            return;				   // 조합 중이므로 동작을 막는다.
        }

        if (e.key === 'Enter' && e.shiftKey) { // [shift] + [Enter] 치면 걍 리턴
            return;
        } else if (e.key === 'Enter') {
            e.preventDefault();	   // [Enter] 치면 메시지 보내기
            handleSendMessage('');
        }
    };

    //채팅 수신
    useEffect(() => {

        const listener = (message) => {

            if (!message) return;

            setTextAnimation(true);

            //상대방 메시지 저장
            setMessages((prevMessages) => [...prevMessages, message]);
            scrollToBottom();

        }
        // 채팅 메세지
        socket.on('incommingMessage', listener);

        return () => {
            socket.off('incommingMessage', listener);
        };

    }, [socket]);


    React.useEffect(() => {
        document.body.classList.add("bg-white");
        return () => {
            document.body.classList.remove("bg-white");
        };
    }, []);

    const deteTime = (dete) => {

        const hour = dete.getHours(); // 시간 (0-23)
        const minute = dete.getMinutes(); // 분 (0-59)
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        if (hour < 12) {
            const time = '오전 ';
            const returnDate = time + hour + ':' + formattedMinutes;

            return returnDate;
        } else {
            const time = '오후 ';
            const returnDate = time + (hour - 12) + ':' + formattedMinutes;

            return returnDate;
        }

    }

    //텍스트 입력 전 모션
    function TypingAnimation({ text, speed }) {
        const [displayText, setDisplayText] = useState('.');

        useEffect(() => {
            let currentIndex = 0;
            let timerId;

            const intervalId = setInterval(() => {
                timerId = setTimeout(() => {
                    clearInterval(intervalId);
                    setTextAnimation(false);
                }, 1500);


                if (currentIndex < text.length - 1) {
                    setDisplayText((prevText) => prevText + ' ' + text[currentIndex]);
                    currentIndex += 1;
                } else {
                    setDisplayText((prevText) => prevText.slice(4));
                    currentIndex -= 2;
                    // clearInterval(intervalId);
                }
            }, speed);



            return () => { clearInterval(intervalId); clearTimeout(timerId); }

        }, [text, speed]);

        return <div>{displayText}</div>;
    }

    const navbarStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1000,
        backgroundColor: '#fff',
        padding: '10px',
    };

    // 채팅 보이는 조건
    const renderMessageText = (index, messages, textAnimation) => {
        const message = messages[index];

        //챗봇 답변 로딩
        // if (index === messages.length - 1 && messages.length > 1) {
        if (index === messages.length - 1 && messages.length > 1) {
            //애니메이션 실행

            //메시지 타입이 링크일 경우
            if (message.chatType == 'L') {
                //대체 텍스트 없으면 그냥 url
                return textAnimation ? <TypingAnimation text="..." speed={650} /> : <a href={message.text} target="_blank">{message.linkText ? message.linkText : message.text}</a>;
            }
            //메시지 타입이 버튼일 경우
            else if (message.chatType == 'B') {
                return <div className='col'>
                    <div>정확한 답변을 위해</div>
                    <div className='mb-2'>아래의 보기를 클릭해주세요.</div>
                    {message.text &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block ml-1"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered ? '#0591D9' : 'black',
                                border: isHovered ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            {message.text}
                        </button>}
                    {message.text2 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text2);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered2 ? '#0591D9' : 'black',
                                border: isHovered2 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered2(true)}
                            onMouseLeave={() => setIsHovered2(false)}
                        >
                            {message.text2}
                        </button>}
                    {message.text3 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text3);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered3 ? '#0591D9' : 'black',
                                border: isHovered3 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered3(true)}
                            onMouseLeave={() => setIsHovered3(false)}
                        >
                            {message.text3}
                        </button>
                    }
                    {message.text4 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text4);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered4 ? '#0591D9' : 'black',
                                border: isHovered4 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered4(true)}
                            onMouseLeave={() => setIsHovered4(false)}
                        >
                            {message.text4}
                        </button>
                    }

                </div>
            }
            //메시지 타입이 일반 텍스트일 경우
            else {

                return textAnimation ? <TypingAnimation text="..." speed={650} /> : message.text;
            }

        }
        else {
            //메시지 타입이 링크일 경우
            if (message.chatType == 'L') {
                //대체 텍스트 없으면 그냥 url
                return <a href={message.text} target="_blank">{message.linkText ? message.linkText : message.text}</a>;
            }
            //메시지 타입이 버튼일 경우
            else if (message.chatType == 'B') {
                return <div className='col'>
                    <div>정확한 답변을 위해</div>
                    <div className='mb-2'>아래의 보기를 클릭해주세요.</div>
                    {message.text &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block ml-1"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered ? '#0591D9' : 'black',
                                border: isHovered ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >
                            {message.text}
                        </button>}
                    {message.text2 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text2);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered2 ? '#0591D9' : 'black',
                                border: isHovered2 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered2(true)}
                            onMouseLeave={() => setIsHovered2(false)}
                        >
                            {message.text2}
                        </button>}
                    {message.text3 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text3);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered3 ? '#0591D9' : 'black',
                                border: isHovered3 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered3(true)}
                            onMouseLeave={() => setIsHovered3(false)}
                        >
                            {message.text3}
                        </button>
                    }
                    {message.text4 &&
                        <button
                            onClick={(e) => {
                                handleSendMessage(message.text4);
                            }}
                            color="primary"
                            className="btn text-center pl-2 pr-2 pt-1 pb-1 mb-2 d-block"
                            style={{
                                backgroundColor: '#ffffff',
                                fontSize: '13px',
                                minWidth: '150px',
                                color: isHovered4 ? '#0591D9' : 'black',
                                border: isHovered4 ? '1.5px solid #0591D9' : '1.5px solid #ffffff',
                                boxShadow: 'none'
                            }}
                            onMouseEnter={() => setIsHovered4(true)}
                            onMouseLeave={() => setIsHovered4(false)}
                        >
                            {message.text4}
                        </button>
                    }

                </div>
            }
            //메시지 타입이 일반 텍스트일 경우
            else {

                return message.text;
            }
        }
    };

    return (
        <div>
            <div ref={messageRef} className="container mt-1 text_div bg-white mb-5 " style={{ paddingTop: 30, paddingBottom: 30 }}>
                <div>
                    <style>
                        {`
                        /* Chrome 및 Safari 스크롤바 숨기기 */
                        ::-webkit-scrollbar {
                        width: 0 !important; /* 스크롤바 너비를 0으로 설정하여 숨깁니다. */
                        }
                  `}
                    </style>
                    <div
                        style={navbarStyle} >

                        <Link to={`/chatbot/${u_uuid}`} style={{ color: '#777777', paddingLeft: 5 }}>
                            <FontAwesomeIcon icon={faAngleLeft} className='mt-2' />
                        </Link>
                    </div>
                    {messages.map((message, index) => (
                        <div className={message.ownerType === 'user' ? "row align-items-center my-3" : "row align-items-center my-3"}
                            style={message.ownerType === 'user' ? { textAlign: right, marginLeft: auto } : {}}
                        >
                            <div className={message.ownerType === 'user' ? "d-none" : "col-auto px-2 align-self-start"} >
                                <img
                                    src={`${CMM.SERVER_URL_API}/files/${img}`}
                                    width="33"
                                    height="33"
                                    className=' rounded-circle '
                                />
                            </div>
                            <div className={message.ownerType === 'user' ? "col px-2" : "col p-0"}>
                                <div className="rounded p-2 d-inline-block m-0 "
                                    style={{
                                        maxWidth: '70%',
                                        backgroundColor: message.ownerType === "user" ? '#0591D9' : '#E6E6E6',
                                        color: message.ownerType === "user" ? '#ffffff' : '#000000',
                                        textAlign: message.ownerType === "user" ? 'left' : '',
                                        wordWrap: "break-word"
                                    }}>
                                    {renderMessageText(index, messages, textAnimation)}</div>
                                <div style={{ fontSize: '13px' }}>{deteTime(currentDate)}</div>
                            </div>
                        </div>
                    ))
                    }
                </div>
                <div className="" ref={messagesEndRef} />
            </div >

            <div className=" bg-white fixed-bottom p-3" style={{ border: "none" }}>
                <div className="input-group">
                    <input ownerType="text" className="form-control" placeholder="메시지를 입력하세요" onKeyDown={(e) => activeEnter(e)}
                        value={inputMessage}
                        onChange={(e) => {
                            setInputMessage(e.target.value)
                        }}
                        style={{ boxShadow: "none" }}
                    />
                    {/* <div className="input-group-append">
                        <button className="btn btn-primary" ownerType="button" onClick={(e) => {
                            e.preventDefault();
                            handleSendMessage(socket)
                        }}>전송</button>
                    </div> */}
                </div>
            </div>
        </div >

    );
}

export default ChatPage;
